import { render, staticRenderFns } from "./SettingsMenu.vue?vue&type=template&id=83e336cc&scoped=true"
import script from "./SettingsMenu.vue?vue&type=script&lang=ts"
export * from "./SettingsMenu.vue?vue&type=script&lang=ts"
import style0 from "./SettingsMenu.vue?vue&type=style&index=0&id=83e336cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83e336cc",
  null
  
)

export default component.exports